module.exports = __webpack_public_path__ + "img/icon-white-2.6fe1b755.svg";